// Public-facing pricing copy for SEO/service/city pages.
// Policy: no specific price numbers on public webpages, and the AI chat does
// not quote prices. Customers get a planning range from the Design & Price It
// Yourself tool (/instant-quote) instead.
export const PRICING_COPY = {
  chatCta:
    'Use our Design & Price It Yourself tool for a planning range for your size; formal pricing is confirmed after free on-site measurement.',
  patioCostFaq:
    'Pricing depends on roof style, size, and site conditions. Use our Design & Price It Yourself tool for a planning range for your actual size; your formal quote is confirmed after free on-site measurement.',
  patioCostSeo:
    'Use our Design & Price It Yourself tool for a planning range for your size; formal pricing is confirmed after free on-site measurement.',
  aluminumGlassCompare:
    'Glass usually costs more than aluminum on the same size. Use the Design & Price It Yourself tool to compare both options for your size.',
  aluminumOnly:
    'The Design & Price It Yourself tool gives a planning range for your size; measurement confirms final pricing.',
  glassOnly:
    'The Design & Price It Yourself tool gives a planning range; measurement confirms final pricing.',
  glassVsAluminumShort:
    'Usually yes — glass typically costs more than aluminum for the same size.',
  glassAluminumSameSize:
    'The Design & Price It Yourself tool compares glass and aluminum for your size.',
  threeWayCompare:
    'Use the Design & Price It Yourself tool to get a planning range for your patio size.',
  threeWayShort:
    'The Design & Price It Yourself tool gives a planning range; measurement locks the final price.',
  example12x14Aluminum:
    'Pricing depends on your city, cover type, size, and site conditions. The Design & Price tool provides a planning range for the options you select; free on-site measurement confirms your formal quote.',
  skylineComboNote:
    'Enter your approximate size in the Design & Price It Yourself tool for a useful planning range; formal pricing follows free measurement.',
  sunroomCompare:
    'Sunroom pricing depends on the buildable area, layout, glass, and site conditions. We confirm it after a free on-site measurement.',
  sunroomCost:
    'Sunroom pricing is confirmed after a free on-site measurement.',
  sunroomWallOnly:
    'Final sunroom pricing depends on the buildable area and site conditions; we confirm it after a free on-site measurement.',
  sunroomMoreExpensive:
    'Usually yes — more enclosure, glass, and planning.',
  rainGuide:
    'Aluminum is the practical rain-first starting point. Glass and skyline combo work when light matters too.',
};
